import StyledForm from '../../../styles/StyledForm';
import StyledFormItem from '../../../styles/StyledFormItem';
import Text from '../../shared/Text/Text';
import Input from '../../shared/Input/Input';
import TelephoneInput from '../../shared/TelephoneInput/TelephoneInput';
import { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation';

interface CompanyFormProps {
  isLoading: boolean;
  canEdit?: boolean;
}

const CompanyForm: React.FC<CompanyFormProps> = ({
  isLoading,
  canEdit = true,
}) => {
  const [isLoadingData, setIsLoadingData] = useState(isLoading);
  const { t } = useTranslation();

  useEffect(() => {
    setIsLoadingData(isLoading);
  }, [isLoading]);

  if (isLoading) {
    return (
      <StyledForm margin="0" marginTop="0">
        <StyledFormItem>
          <Skeleton width="100px" />
          <Skeleton />
        </StyledFormItem>
        <StyledFormItem>
          <Skeleton width="100px" />
          <Skeleton />
        </StyledFormItem>
        <StyledFormItem>
          <Skeleton width="100px" />
          <Skeleton />
        </StyledFormItem>
      </StyledForm>
    );
  }

  return (
    <StyledForm margin="0" marginTop="0">
      <StyledFormItem>
        <Text type="label">{t('Company Name')}</Text>
        <Input name="company_name" disabled={!canEdit} />
      </StyledFormItem>
      <StyledFormItem>
        <Text type="label">{t('Company Email')}</Text>
        <Input name="company_email" disabled={!canEdit} />
      </StyledFormItem>
      <TelephoneInput
        name="company_phone"
        labelText={t('Company Phone Number')}
        disabled={!canEdit}
      />
      {!canEdit && (
        <StyledFormItem>
          <small className="info-text">
            {t('Only company admins can update company details')}
          </small>
        </StyledFormItem>
      )}
    </StyledForm>
  );
};

export default CompanyForm;
